































import Component from 'vue-class-component'

import {EventBus, Messages, OrderBus, OrderMessages} from "../../services/EventBus";
import Vue from "vue";
import {OrderTypeMap} from "../../domain/TbMaps";
import {TableOrder} from "../../domain/Order";
import {Emit, Prop, Watch} from "vue-property-decorator";    
import {CurrencyInput, WaitIndicator} from '../Common'
import {CancelOrderRequest, EditOrderRequest} from "../../domain/DTO";
import {Order} from "../../domain/Order";
import {DebitCredit} from "../../domain/types";

// edit tb ajax call inside to allow simultaneous edits
@Component({
    components: {CurrencyInput, WaitIndicator},
    props:{ 'order': {required: true} }

})

class PriceCell extends Vue {

    @Prop({required:false, default:false})
    fixed: boolean;

    order:Order;
    editing: boolean = false;
    //viewPrice: string;
    //viewStop:string;

    newPrice:number|null = null;
    newStop: number|null = null;

    loading: boolean = false;
    tried: boolean  = false;
    get valid(){
        if (this.PriceFieldVisible && ( this.newPrice===null || this.newPrice<=0)) return false;
        if (this.StopFieldVisible && ( this.newStop===null || this.newStop<=0)) return false;
        return true;
    }

    get CrDr(){
        return DebitCredit.GetAbbr(this.order.DebitCredit);
    }

    @Watch('order')
    setEdit(v:TableOrder, old:TableOrder){
        if (v.editing && this.editable) {
            this.prepareFields();
        } else
            this.cancel();
    }

    mounted(){
       //OrderBus.$on(<string>OrderMessages.OrderTableClick, this.cancel)
    }

    beforeDestroy(){
        OrderBus.$off(<string>OrderMessages.OrderTableClick,this.cancel )
    }
    get PriceFieldVisible(){
        return Order.canHavePrice(this.order)
    };
    get StopFieldVisible(){
        return Order.canHaveStop(this.order)
    };
    get Text() {
        return OrderTypeMap[this.order.OrderType] + " ";
    }

    isWorking: boolean;
    orderId: number;

    get editable() {
        return  !this.fixed && Order.isChangeable(this.order) && (Order.canHaveStop(this.order) || Order.canHavePrice(this.order))
    }
    cr:boolean|null=null;
    prepareFields(){
        this.tried = false;
        if (!this.editable) return;

        this.$nextTick(()=>{
            if (Order.canHavePrice(this.order)) {
                this.newPrice = Math.abs(this.order.Price!);
                this.cr = this.order.Price!>=0;
            }
            if (Order.canHaveStop(this.order)) {
                this.newStop = Math.abs(this.order.Stop!);
                this.cr = this.order.Stop!>=0;
            }
            this.$nextTick(()=> {
                this.editing = true;
            });
        })



    }

    cancel(){
        this.editing = false;
    }

    success(){
        this.loading = false;
        this.editing = false;
        if (this.newPrice)  this.order.Price = this.newPrice;
        if (this.newStop)  this.order.Stop = this.newStop;
        OrderBus.$emit(<string>OrderMessages.OrdersEditPriceSuccess, this.order);
    }
    fail(){
        this.loading = false;
        this.editing = false;
    }

    @Emit()
    edit() {

        var req =  {
            OrderId: this.order.OrderId,
            AccountId: this.order.AccountId,
            SubaccountId: this.order.SubaccountId,
            Price: this.newPrice? this.newPrice: null,
            OrderType: this.order.OrderType,
            Stop: this.newStop? this.newStop: null
        } as EditOrderRequest;

        this.tried = true;
        /*if (this.cr && req.Price){
            req.Price = - req.Price;
        }
        if (this.cr && req.Stop){
            req.Price = - req.Price;
        }*/
        this.loading = true;
        /*var xhr = new TradingBlockRemote({onComplete: this.success.bind(this), onFailure: this.fail.bind(this)})
            .EditOrder(req);*/


    }

}

export default PriceCell;
